<template>
  <div id="top">
    <div class="container">
      <div class="row">
        <div class="col-lg-8 offset-lg-2 bg-white pb-5">
          <p class="topMainImg">
            <img
              src="../assets/2024/img_xmas2024.png"
              srcset="../assets/2024/img_xmas2024@2x.png"
              alt="銀のスプーン　生ケーキ予約サイト"
              class="topMainImg__img"
            />
          </p>
          <div class="introduction">
            <div class="row">
              <div class="col-lg-7 about">
                <p class="text1">
                  こちらは銀のすぷーんのクリスマスケーキを、店頭受取予約できるページです。24時間ウェブで簡単にケーキを予約でき、<span
                    class="span"
                    >12月15日(日)までにご注文頂ければ21日(土)〜26日(木)にお渡しが可能</span
                  >です。
                </p>
                <p class="text1">
                  ※<span class="span"
                    >限定台数に達し次第、最終〆切日の12月15日より早く締め切る</span
                  >こともございます。何卒ご了承くださいませ。
                </p>
                <p class="text1" >
                  ※<span class="span"
                    >久留米本店</span
                  >は <span class="span"
                    >26日が店休日</span>のため、 <span class="span"
                    >21日(土)〜25日(水)でのお渡しとなります。</span>
                </p>
              </div>
              <div class="col-lg-5 telInfo">
                <!-- <p class="bg-blue text-center">お電話でのご注文はこちら</p> -->
                <a
                  href="tel:0942350092"
                  class="bg-blue text-center d-inline-block"
                  id="telBtn"
                  >お電話でのご注文はこちら</a
                >
                <p class="c-blue">0942-35-0092</p>
                <p class="telInfo__time">受付時間9時〜18時（月～土）</p>
              </div>
            </div>
          </div>

          <div class="endMessage" v-show="eventEnd">
            <h2>クリスマスケーキのご予約は終了いたしました。</h2>
            <p>たくさんのご予約ありがとうございました。</p>
          </div>

          <div v-show="!eventEnd">
            <div class="caution">
              <p class="caution__text1">ご注文の際は下記にご注意ください</p>
              <p class="caution__text2">
                ※ 価格は全て<span class="span">税込表記</span>です。
                <br />
                <!-- ※
                ご注文直後は注文情報が店頭に届いていない可能性がございますので、<span
                  class="span"
                  >お会計はご注文の翌日以降にお願いしております。</span
                >予めご了承くださいませ。 -->
                <!-- <br /> -->
                ※ お受取り日ごとに、ご用意できる台数が限られております。<span
                  class="span"
                  >締切前でも、お受取日によっては受付を終了することがございます</span
                >ので、どうぞお早めのご予約をお願いいたします。<br />
                ※<span class="span"
                  >ご予約の変更は、お受取りご希望日の3日前までに</span
                >お願いいたします。ご変更のお日にちによってはお受けできない場合もございます。ご了承ください。<br />
                ※<span class="span"
                  >12/23・24・25のホールケーキはパンフレット掲載商品のみの販売</span
                >となります。<br />なお、その他の生菓子のご予約お取り置きは承っておりません。<br />
                ※<span class="span">飾りは写真と異なる場合がございます</span
                >。ご了承ください。<br />
                ※<span class="span">ケーキのサイズはベースの大きさで表記</span
                >しております。<br />
                ※このクリスマスケーキ予約サイトの掲載商品は、<span class="span"
                  >店頭でのお受取りのみ</span
                >とさせていただきます。<br />
                <!-- ※ご予約が集中しますと12月15日の締切日より早く、締め切ることもございます。<br />
                何卒、ご了承くださいませ。 -->
              </p>
            </div>
            <p class="reservationTitle">予約からお受け取りまでの流れ</p>
            <div class="iconCntainer">
              <div class="row iconRow">
                <div class="col-6 col-lg-3 iconCol">
                  <div class="iconBox">
                    <span class="number">1</span>
                    <p>
                      <img
                        src="../assets/img/icon_01.png"
                        srcset="../assets/img/icon_01.svg"
                        alt=""
                      />
                    </p>
                  </div>
                  <p class="iconBox__desc">ご予約ページより予約します。</p>
                </div>
                <div class="col-6 col-lg-3 iconCol">
                  <div class="iconBox">
                    <span class="number">2</span>
                    <p class="icon2">
                      <img
                        src="../assets/img/icon_02.png"
                        srcset="../assets/img/icon_02.svg"
                        alt=""
                      />
                    </p>
                  </div>
                  <p class="iconBox__desc">ご注文完了後にメールが届きます。</p>
                </div>
                <div class="col-6 col-lg-3 iconCol">
                  <div class="iconBox">
                    <span class="number">3</span>
                    <p class="icon3">
                      <img
                        src="../assets/img/icon_03.png"
                        srcset="../assets/img/icon_03.svg"
                        alt=""
                      />
                    </p>
                  </div>
                  <p class="iconBox__desc">
                    当日店頭にてお名前と、予約番号をお伝え下さい。
                  </p>
                </div>
                <div class="col-6 col-lg-3 iconCol">
                  <div class="iconBox">
                    <span class="number">4</span>
                    <p>
                      <img
                        src="../assets/img/icon_04.png"
                        srcset="../assets/img/icon_04.svg"
                        alt=""
                      />
                    </p>
                  </div>
                  <p class="iconBox__desc">
                    ケーキお受け取りの際にお支払いをお願いいたします。
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div class="present">
            <h2 class="present-tit">早期ご予約特典</h2>
            <div class="present-content">
              <p class="present-catch">
                11月30日(土)までのご予約で、先着500名様にクリスマスプレゼント!
              </p>
              <p class="present-text">
                ●
                11月1日~30日までにお支払いいただいた方から先着とさせていただきます。<br />
                ● 特典はなくなり次第、終了とさせていただきます。<br />
                ●
                ご注文直後は注文情報が店頭に届いていない可能性がございますので、<span
                  class="span"
                  >お会計はご注文の翌日以降にお願いしております。</span
                >予めご了承くださいませ。
              </p>
            </div>
          </div>
          <!-- <div class="present present-covid">
            <h2 class="present-tit">新型コロナウイルスへの対策について</h2>
            <div class="present-content">
              <p class="present-text">
                ※新型コロナウイルス感染拡大防止のため、店頭の消毒など万全を期しております。<br />
                ※マスク着用でのご来店をお願いしておりますので、ご協力をお願いいたします。<br />
                ※混み合う時間帯は、入場制限をさせていただきます。<br />
                ※ご予約があるお客様から優先してご入店いただきます。ご予約をいただきますと滞在時間も短く、比較的スムーズなお渡しが可能となるかと思いますのでぜひ、事前ご予約をご利用くださいませ。
              </p>
            </div>
          </div> -->
          <div class="present present-date">
            <h2 class="present-tit">ご予約のお受取日について</h2>
            <div class="present-content">
              <p class="present-text">
               クリスマスケーキのご予約は<strong>久留米本店</strong>(文化センター通り)は<strong>12月21日(土)～25日(水)まで、博多マイング店</strong>(JR博多駅 マイング名店街)は<strong>12月21日(土)～26日(木)まで</strong>をお受取日としてご指定いただけます。<br />
              </p>
            </div>
          </div>

          <div class="btn_reserve">
            <router-link
              to="/reservation"
              class="btn btn_icon"
              v-show="!eventEnd"
            >
              <picture
                ><source
                  type="image/svg+xml"
                  srcset="../assets/img/btn_icon01.svg"
              /></picture>
              <img
                src="../assets/img/btn_icon01.png"
                srcset="../assets/img/btn_icon01@2x.png"
                alt="icon"
              />
              クリスマスケーキのご予約はこちら<i
                class="fas fa-chevron-right"
              ></i>
            </router-link>
            <!-- <a href="../" class="btn btn_other btn_icon">
              <picture
                ><source
                  type="image/svg+xml"
                  srcset="../assets/img/btn_icon02.svg"
              /></picture>
              <img
                src="../assets/img/btn_icon02.png"
                srcset="../assets/img/btn_icon02@2x.png"
                alt="icon"
              />
              その他ケーキのご予約はこちら<i class="fas fa-chevron-right"></i>
            </a> -->
          </div>

          <!-- ドメイン拒否の注意書き -->
          <div class="domeinNotice">
            <h3 class="domeinNotice__ttl">各携帯会社のドメイン指定解除方法</h3>
            <p class="domeinNotice__txt">
              ｢ドメイン指定受信｣など，一部アドレスからのメールのみ許可する設定の手順は，各携帯電話会社によって異なります｡（詳しくはお手持ちの携帯電話の取り扱い説明書をご覧ください）
            </p>
            <p class="domeinNotice__txt">
              ドメイン指定受信を設定する場合は，以下のドメインを指定してください｡
            </p>
            <p class="domeinNotice__txt">
              弊社からの返信は｢web-order-event@g-spoon.co.jp｣の指定をお願い致します｡
            </p>
            <h3 class="domeinNotice__subTtl">ドメイン指定受信設定方法</h3>
            <dl class="list">
              <dt>Docomo</dt>
              <dd>
                iメニュー→オプション設定→メール設定→メール受信設定[受信/拒否設定]→ドメイン指定受信→受信したいドメインまたはアドレスの欄にドメイン｢g-spoon.co.jp｣または｢web-order-event@g-spoon.co.jp｣を入力→i-modeパスワードを入力→決定→設定完了
              </dd>
            </dl>
            <dl class="list mt-4 mb-4">
              <dt>SoftBank</dt>
              <dd>
                Yahoo!ケータイメニュー→My
                SoftBank→オリジナルメール設定･各種メール設定→暗証番号を入力→迷惑メール関連設定→受信拒否･許可アドレスの設定
                →受信｢許可ﾘｽﾄとして設定｣→[一括指定]
                または[個別アドレスの追加]→｢個別アドレスの追加｣するを選択ドメインを入力後，ドメイン｢g-spoon.co.jp｣または｢web-order-event@g-spoon.co.jp｣を選択→設定完了
              </dd>
            </dl>
            <dl class="list">
              <dt>au</dt>
              <dd>
                Eメールメニュー→Eメール設定→その他の設定→メールフィルター→暗証番号を入力→アドレスフィルター→個別設定[指定受信リスト設定→指定受信設定
                →【個別指定】にドメイン｢g-spoon.co.jp｣または｢web-order-event@g-spoon.co.jp｣を入力→設定完了
              </dd>
            </dl>
          </div>
          <!-- ドメイン拒否の注意書き -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "top",
  data() {
    return {
      eventEnd: false,
    };
  },
  mounted() {
    const pageHeaderCartBtn = document.getElementById("pageHeaderCartBtn");
    pageHeaderCartBtn.style.display = "none";
    const pageHeaderCartBtn_first = document.getElementById(
      "pageHeaderCartBtn_first"
    );
    pageHeaderCartBtn_first.style.display = "block";
  },
  updated() {
    const pageHeaderCartBtn = document.getElementById("pageHeaderCartBtn");
    pageHeaderCartBtn.style.display = "none";
    this.radioResult = "";
    this.reservation.cart = [];
    this.seenCart = false;
    this.reservation.hiddenSum = 0;
    this.reservation.tax = 0;
    this.reservation.sum = 0;
    this.reservation.count = 0;
    this.reservation.showItemList = [];
    this.reservation.itemList = [];
    this.reservation.totalCartItemNumber = 0;
  },
  head: {
    title: {
      inner: "福岡でクリスマスケーキケーキの予約・テイクアウト",
      separator: "|",
      complement: "銀のすぷーん予約サイト",
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
#top {
  background: #edecea url(https://g-spoon.co.jp/img/img_bg01@2x.png) center left /
    1262px auto repeat;
  padding-top: 70px;
  padding-bottom: 70px;
  font-family: 游明朝, "Yu Mincho", YuMincho, "Hiragino Mincho ProN", HGS明朝E,
    メイリオ, Meiryo, serif;
}
.endMessage {
  text-align: center;
  margin: 6rem 0;
  h2 {
    font-size: 1.6rem;
    color: #831f17;
    font-weight: bold;
  }
  p {
    font-size: 1.4rem;
    font-weight: bold;
  }
}
.btn_icon {
  img {
    max-width: 30px;
  }
}
.btn_other {
  margin: 30px 0 40px;
  background: #0d446f !important;
}
.present {
  border-radius: 3px;
  overflow: hidden;
  margin-bottom: 30px;
  &-tit {
    background-color: #eb8444;
    color: #fff;
    padding: 15px;
    font-size: 20px;
    text-align: center;
    margin-bottom: 0;
  }
  &-content {
    border: #eb8444 1px solid;
    padding: 15px;
    border-bottom-left-radius: 3px;
    border-bottom-right-radius: 3px;
  }
  &-catch {
    color: #e21616;
    font-size: 20px;
    text-align: center;
  }
  &-text {
    font-size: 14px;
    line-height: 1.8em;
    // padding-right: 120px;
    // background: url(../assets/img/img_present-2021@2x.png) right top / 60px auto
    //   no-repeat;
  }
  &-covid {
    .present-tit {
      background: #c65c5c;
    }
    .present-text {
      padding-right: 0;
      padding-bottom: 100px;
      background: url(https://g-spoon.co.jp/img/icon_mask@2x.png) center bottom /
        200px auto no-repeat;
    }
  }
  &-date {
    .present-tit {
      background: #0d446f;
    }
    .present-content {
      border-color: #0d446f;
    }
    .present-text {
      padding-right: 0;
      background: none;
    }
  }
}
.span {
  font-weight: bold;
  color: #831f17;
}
.topMainImg {
  margin-top: 80px;
  padding: 0 15px;
  @media (max-width: 767.98px) {
    margin-top: 70px;
  }
  &__img {
    max-width: 100%;
  }
}
.bg-blue {
  background-image: linear-gradient(to right, #23543c 4%, #0f281c);
  color: #fff;
  padding: 5px 20px;
  border-radius: 50px;
  font-size: 14px;
  margin-bottom: 10px;
  @media (max-width: 991.98px) {
    // width: 80%;
    margin: auto;
    margin-bottom: 10px;
  }
}
.c-blue {
  font-size: 36px;
  font-weight: 500;
  font-style: normal;
  font-stretch: normal;
  line-height: 0.89;
  letter-spacing: normal;
  text-align: center;
  color: #193f2d;
}
.introduction {
  padding: 0 15px;
  .text1 {
    text-align: left;
  }
  .telInfo {
    text-align: center;
    &__time {
      font-size: 15px;
      font-weight: 500;
      line-height: 1.53;
      color: #333333;
      text-align: center;
    }
  }
}
.caution {
  border-radius: 5px;
  background-color: #f6f6f6;
  border: solid 1px #eeeeee;
  margin: 0 15px;
  padding: 0 15px;
  &__text1 {
    color: #c65c5c;
    text-align: center;
    font-size: 18px;
    font-weight: 500;
    line-height: 1.28;
    margin-top: 17px;
    @media (max-width: 575.98px) {
      font-size: 16px;
    }
  }
  &__text2 {
    font-size: 14px;
    font-weight: 500;
    line-height: 1.64;
    text-align: left;
    color: #333333;
  }
}
.reservationTitle {
  font-size: 21px;
  font-weight: 500;
  line-height: 1.1;
  text-align: center;
  color: #ae952f;
  margin-top: 30px;
  margin-bottom: 42px;
}
.iconCntainer {
  padding: 0 15px;
  .iconBox {
    position: relative;
    border-radius: 5px;
    background-color: #f6f6f6;
    border: solid 1px #eeeeee;
    min-height: 130px;
    .number {
      position: absolute;
      top: -10px;
      left: 50%;
      margin-left: -10px;
      font-size: 36px;
      font-weight: 500;
      line-height: 0.64;
      text-align: center;
      color: #193f2d;
    }
    p {
      text-align: center;
      padding: 0 20px;
      margin-top: 40px;
    }
    .icon3 {
      margin-bottom: 5px;
    }
    &__desc {
      margin-top: 15px;
      margin-bottom: 30px;
    }
  }
}
.btn {
  position: relative;
  background-color: #831f17;
  color: #fff;
  display: block;
  padding-top: 20px;
  padding-bottom: 20px;
  font-family: 游明朝, "Yu Mincho", YuMincho, "Hiragino Mincho ProN", HGS明朝E,
    メイリオ, Meiryo, serif;
  font-size: 20px;
  line-height: 1.15;
  text-align: center;
  color: #ffffff;
  &:hover {
    opacity: 0.7;
  }
  i {
    position: absolute;
    top: 50%;
    right: 30px;
    margin-top: -0.6em;
    font-size: 20px;
    line-height: 1.15;
    font-weight: bold;
  }
}
//電話をかけるのボタン
#telBtn {
  &:hover {
    opacity: 0.7;
    text-decoration: none;
  }
}
//サクリスタンプレゼントメッセージ
.presentMsg {
  border: 1px #ecb2cb dashed;
  padding: 15px 10px;
  border-radius: 10px;
  line-height: 2;
}
// sp時に下部に固定
.btn_reserve {
  @media (max-width: 575.98px) {
    position: fixed;
    bottom: 0;
    right: 0;
    left: 0;
    .btn {
      margin: 0 0 0 0;
    }
  }
}

// ドメイン拒否の注意書き
.domeinNotice {
  border-radius: 5px;
  background-color: #f6f6f6;
  border: solid 1px #eeeeee;
  padding: 15px;
  margin-top: 50px;
  &__ttl {
    color: #193f2d;
    font-weight: bold;
    font-size: 20px;
  }
  &__txt {
    font-size: 14px;
  }
  &__subTtl {
    font-size: 16px;
    color: #193f2d;
    border: #193f2d 1px solid;
    display: inline-block;
    padding: 5px 15px;
  }
  .list {
    margin-top: 10px;
    dt {
      background: #193f2d;
      display: inline;
      color: #fff;
      padding: 4px 10px;
      border-radius: 5px;
      font-size: 15px;
    }
    dd {
      margin-top: 7px;
      font-size: 14px;
    }
  }
}
</style>
